module.exports = __webpack_public_path__ + "static/media/22_B.055a0fe2.png";